import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { Link, useNavigate } from 'react-router-dom';
import Rating from './Rating';
import { useContext, useEffect, useState } from 'react';
import { Store } from '../Store';
import axios from 'axios';

function Product(props) {
  const { product } = props;
  const navigate = useNavigate();
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    cart: { cartItems },
  } = state;
  const [toRedirectCart, setToRedirectCart] = useState(false);

  const addToCartHandler = async (item) => {
    const existItem = cartItems.find((x) => x._id === product._id);
    const quantity = existItem ? existItem.quantity + 1 : 1;
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/products/${item._id}`
    );
    if (data.countInStock < quantity) {
      window.alert('Sorry. Product is out of stock');
      return;
    } else {
      setToRedirectCart(true);
    }
    ctxDispatch({
      type: 'CART_ADD_ITEM',
      payload: { ...item, quantity },
    });
  };

  useEffect(() => {
    if (toRedirectCart) navigate('/cart');
  }, [navigate, toRedirectCart]);

  return (
    <Card>
      <Link to={`/product/${product.slug}`}>
        <img src={product.image} className="" alt={product.name} />
      </Link>
      <Card.Body>
        <Link to={`/product/${product.slug}`}>
          <Card.Title>{product.name}</Card.Title>
        </Link>
        <Rating rating={product.rating} numReviews={product.numReviews} />
        <Card.Text>${product.price}</Card.Text>
        {product.countInStock > 0 ? (
          <Button onClick={() => addToCartHandler(product)}>Add to cart</Button>
        ) : (
          <Button variant="light" disabled>
            Out of stock
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}
export default Product;
